/**
 * Section placeholder while lazy chunks load.
 * Grid + neon pulse + brand mark — same language as the rest of the site.
 */
export default function SectionLoader({ minHeight = '400px', label = 'ROI' }) {
  return (
    <div
      className="relative overflow-hidden bg-dark flex items-center justify-center"
      style={{ minHeight }}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="absolute inset-0 ig-grid opacity-35 pointer-events-none" aria-hidden="true" />
      <div
        className="neon-halo w-[min(55vw,320px)] h-[min(55vw,320px)] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-60 animate-neon-pulse"
        aria-hidden="true"
      />

      <div className="relative z-10 flex flex-col items-center gap-5 px-6">
        <div className="relative">
          <div
            className="absolute -inset-3 rounded-full border border-primary/25 roi-loader-ring"
            aria-hidden="true"
          />
          <div
            className="absolute -inset-6 rounded-full border border-primary/10 roi-loader-ring-slow"
            aria-hidden="true"
          />
          <div className="relative flex h-14 w-14 items-center justify-center rounded-2xl border border-primary/30 bg-dark-panel/80 shadow-glow-sm backdrop-blur-sm">
            <span className="font-display text-sm font-bold uppercase tracking-[0.2em] text-neon">
              {label}
            </span>
          </div>
        </div>

        <div className="flex flex-col items-center gap-3 w-full max-w-xs">
          <div className="h-2 w-28 rounded-full roi-shimmer" aria-hidden="true" />
          <div className="h-2 w-20 rounded-full roi-shimmer opacity-60" aria-hidden="true" />
        </div>

        <span className="sr-only">Loading</span>
      </div>
    </div>
  );
}
